<template>
  <!-- Unified telephony health / result card. Feed it a normalized panel:
       { headerLevel: 'ok'|'warn'|'error', title, rows: [{ level, text, detail }] }.
       Shared by Check VPS, Check trunk, Check mini-PC, Sync config so every
       diagnostic reads the same way — severity encoded by a colored dot + tint. -->
  <div
    v-if="panel"
    class="tel-ui rounded-xl border overflow-hidden"
    :class="panel.headerLevel === 'ok' ? 'border-emerald-200' : (panel.headerLevel === 'error' ? 'border-red-200' : 'border-amber-200')"
  >
    <div
      class="flex items-center gap-2 px-3 py-2 border-b"
      :class="{
        'bg-emerald-50 border-emerald-200 text-emerald-800': panel.headerLevel === 'ok',
        'bg-amber-50 border-amber-200 text-amber-800': panel.headerLevel === 'warn',
        'bg-red-50 border-red-200 text-red-800': panel.headerLevel === 'error'
      }"
    >
      <span
        class="inline-flex h-4 w-4 items-center justify-center rounded-full text-white text-[10px] font-bold flex-shrink-0"
        :class="{ 'bg-emerald-500': panel.headerLevel === 'ok', 'bg-amber-500': panel.headerLevel === 'warn', 'bg-red-500': panel.headerLevel === 'error' }"
      >{{ panel.headerLevel === 'ok' ? '✓' : (panel.headerLevel === 'error' ? '✕' : '!') }}</span>
      <span class="text-sm font-semibold leading-tight">{{ panel.title }}</span>
    </div>
    <ul v-if="panel.rows && panel.rows.length" class="divide-y divide-slate-100 bg-white">
      <li v-for="(row, ri) in panel.rows" :key="ri" class="flex items-start gap-2.5 px-3 py-2">
        <span
          class="mt-1 h-2 w-2 rounded-full flex-shrink-0"
          :class="{ 'bg-emerald-500': row.level === 'ok', 'bg-red-500': row.level === 'error',
                    'bg-amber-500': row.level === 'warn', 'bg-slate-300': row.level === 'info' }"
        ></span>
        <div class="min-w-0">
          <p
            class="text-xs leading-snug"
            :class="row.level === 'error' ? 'text-red-700' : (row.level === 'warn' ? 'text-amber-700' : 'text-slate-700')"
          >{{ row.text }}</p>
          <p v-if="row.detail" class="text-[11px] text-slate-400 tabular-nums mt-0.5">{{ row.detail }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "TelHealthCard",
  props: {
    panel: { type: Object, default: null },
  },
};
</script>
